module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "persons"
  }, [_vm._l((_vm.personsGroupByPosition), function(personsGroup, key) {
    return [(_vm.isUnSelectedSinglePeronPin(personsGroup)) ? _c('pin-person-single', {
      key: key,
      attrs: {
        "person": personsGroup[0],
        "visualization-pin-size": _vm.visualizationPinSize
      }
    }) : (_vm.isUnSelectedMultiplePeronPin(personsGroup)) ? _c('pin-person-multiple', {
      key: key,
      attrs: {
        "persons": personsGroup,
        "visualization-pin-size": _vm.visualizationPinSize
      }
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.selectedSinglePersonPin) ? _c('pin-person-single', {
    attrs: {
      "person": _vm.selectedSinglePersonPin,
      "visualization-pin-size": _vm.visualizationPinSize
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedMultiplePersonPin) ? _c('pin-person-multiple', {
    attrs: {
      "persons": _vm.selectedMultiplePersonPin,
      "visualization-pin-size": _vm.visualizationPinSize
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ece60f2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/pin/person.vue
// module id = 756
// module chunks = 0